/* eslint-disable multiline-comment-style */
const { log } = console
const {
  fetchJson,
  parseSb3,
  loadGlitchSb3,
  loadPartSb3,
  fetchSceneMetadata,
  fetchSceneSb3
} = require('./utils/fetch-and-parse.js')


module.exports = function load (state, emitter) {
  emitter.on('fetch-project-metadata', projectId => {
    log('fetch-project-metadata', projectId)
    state.projectId = projectId

    if (state.availableProjects.find(p => p.id === projectId)) {
      fetchJson(`provision/projects/${projectId}/${projectId}.json`)
        .then(metadata => {
          state.projectMetadata = metadata
          emitter.emit('render')
        })
    } else {
      state.projectMetadata = {
        id: projectId,
        title: 'title',
        exposedVariables: [],
        scenes: [{attemptRemoteLoad: true}]
      }
      state.projectData = {attemptRemoteLoad: true}
      state.sceneMetadata = { }
      state.sceneData = {attemptRemoteLoad: true, id: projectId}
      emitter.emit('load-scene')
    }
  })

  emitter.on('fetch-scene-metadata', sceneId => {
    log('fetch-scene-metadata', sceneId)
    if (state.projectMetadata) {
      fetchSceneMetadata(sceneId, state.projectMetadata).then(result => {
        state.sceneMetadata = result
        emitter.emit('render')
      })
    }
  })


  emitter.on('fetch-scene-sb3', sceneId => {
    log('fetch-scene-sb3', sceneId)
    if (state.projectMetadata) {
      fetchSceneSb3(sceneId, state.projectMetadata).then(result => {
        state.sceneData = result
        emitter.emit('render')
      })
    }
  })

  emitter.on('load-glitches', () => {
    log('load-glitches')
    const subcategories = []
    state.availableGlitches.forEach(g => {
      if (g.category) {
        subcategories[g.category] = {
          id: g.category,
          color: g.color
        }
      }
    })
    state.glitchCategories = Object.values(subcategories)
    state.selectedGlitchCategories = state.glitchCategories.map(c => c.id)
    const promises = state.availableGlitches.map(
      glitch => loadGlitchSb3(glitch).then(
        sb3 => parseSb3(sb3, state.vm)
      )
    )

    Promise.all(promises).then(results => {
      results.forEach((parsedGlitch, i) => {
        state.availableGlitches[i].code = parsedGlitch.code
        state.availableGlitches[i].zip = parsedGlitch.zip
        state.availableGlitches[i].sb3 = parsedGlitch.sb3
      })
      state.glitchesLoaded = true
      emitter.emit('render')
    })
  })

  emitter.on('load-parts', () => {
    log('load-parts')
    const promises = state.availableParts.map(
      part => loadPartSb3(part).then(
        sb3 => parseSb3(sb3, state.vm)
      )
    )

    Promise.all(promises).then(results => {
      results.forEach((parsedPart, i) => {
        state.availableParts[i].code = parsedPart.code
        state.availableParts[i].zip = parsedPart.zip
      })
      state.partsLoaded = true
      emitter.emit('render')
    })
  })
}
